export function createPDFFileName(itemERPCode, receivedItemDescription) {
  // Check if the item ERP code is not "N/A", otherwise use "Quality Report" as a fallback
  const itemCode = itemERPCode !== "N/A" ? itemERPCode : "Quality Report";

  // Check if the received item description is not undefined, otherwise use "Quality Report" as a fallback
  const itemDescription =
    receivedItemDescription !== undefined
      ? receivedItemDescription
      : "Quality Report";

  // Determine the PDF file name based on the item code and description
  // If both are "Quality Report", use "Quality Report" as the file name
  // Otherwise, concatenate the code and description with a separator
  const pdfFileName =
    itemCode === "Quality Report" && itemDescription === "Quality Report"
      ? "Quality Report"
      : `${itemCode} - ${itemDescription}`;
  return pdfFileName;
}
